module.exports = __webpack_public_path__ + "static/media/vignette.3dd500bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/vignette.png
// module id = 90
// module chunks = 0